import { useQuery } from '@tanstack/react-query';
import { apiCall } from '@/lib/api-client';

export interface ReviewAnswer {
  domain: string;
  answer: Record<string, unknown>;
  notes: string | null;
  positiveFinding: boolean;
  answeredAt: string;
}

export interface ScreeningReview {
  id: string;
  assignmentId: string;
  agentId: string;
  startedAt: string;
  submittedAt: string | null;
  completedAt: string | null;
  isSubmitted: boolean;
  consentGiven: boolean;
  recordingNoticeGiven: boolean;
  languageUsed: string;
  timeCategory: string | null;
  totalDurationSec: number | null;
  nextStepNavigator: boolean | null;
  findhelpSubmitted: boolean;
  findhelpScreeningId: string | null;
  safetyTotalScore: number | null;
  safetyConcernFlag: boolean | null;
  positiveDomains: string[];
  positiveFindingsCount: number;
  answers: ReviewAnswer[];
  client: {
    id: string;
    cin: string;
    firstName: string;
    lastName: string;
    dob: string;
    addressLine1: string | null;
    city: string | null;
    postalCode: string | null;
    phoneHome: string | null;
    phoneCell: string | null;
    phoneOther: string | null;
    preferredLanguage: string | null;
  };
}

export function useScreeningReview(screeningId: string | null) {
  return useQuery({
    queryKey: ['screening', 'review', screeningId],
    queryFn: () => apiCall<ScreeningReview>(`/screenings/${screeningId}/review`),
    enabled: !!screeningId,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
